import { Radio, RadioProps, styled, Box } from "@mui/material";
import { tokens } from "../../theme/tokens";

const CustomRadioIcon = styled(Box)<{ disabled?: boolean }>(({ disabled }) => ({
  width: '18px',
  height: '18px',
  borderRadius: '50%',
  border: `2px solid ${disabled ? tokens.colors.midGrey : tokens.colors.midGrey}`,
  backgroundColor: 'transparent',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const CustomRadioCheckedIcon = styled(Box)<{ disabled?: boolean }>(({ theme, disabled }) => ({
  width: '18px',
  height: '18px',
  borderRadius: '50%',
  border: `2px solid ${disabled ? tokens.colors.midGrey : theme.palette.primary.main}`,
  backgroundColor: disabled ? tokens.colors.midGrey : theme.palette.primary.main,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '&::after': {
    content: '""',
    width: '6px',
    height: '6px',
    borderRadius: '50%',
    backgroundColor: tokens.colors.offWhite,
  },
}));

const StyledRadio = styled(Radio)<RadioProps>(({ theme }) => ({
  padding: '8px',
  '&:hover': {
    backgroundColor: `${theme.palette.primary.main}1F`,
  },
  '&.Mui-focusVisible': {
    outline: `2px dashed ${theme.palette.primary.main}`,
    outlineOffset: '4px',
  },
  '&.Mui-disabled': {
    cursor: 'not-allowed',
  },
}));

export const TrackNowRadio = (props: RadioProps) => {
  return (
    <StyledRadio
      {...props}
      disableRipple
      icon={<CustomRadioIcon disabled={props.disabled} />}
      checkedIcon={<CustomRadioCheckedIcon disabled={props.disabled} />}
    />
  );
};